import React, { useState, useEffect } from "react";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMediaQuery, useTheme } from "@mui/material";

const CourseInstructors: React.FC<
  Pick<NSCourses.IAboutProps, "courseInstructors">
> = ({ courseInstructors }) => {
  const theme = useTheme();
  const isUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const [expanded, setExpanded] = useState(false);

  // Show contributors on desktop
  useEffect(() => {
    if (isUpMd) {
      setExpanded(true);
    }
  }, [isUpMd]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        [theme.breakpoints.down("md")]: { justifyContent: "center" },
      }}
    >
      <Box
        py={4}
        px={8}
        width={350}
        borderRadius={5}
        boxShadow="0px 6.69914px 34px rgba(81, 175, 91, 0.05), inset 0px 2.51218px 0px rgba(219, 237, 255, 0.18), inset 0px -2.51218px 3px rgba(81, 175, 91, 0.21)"
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              sx: {
                [theme.breakpoints.down("sm")]: {
                  fontSize: theme.spacing(4),
                },
              },
            }}
          >
            Contributors & Instructors
          </Typography>
          <IconButton onClick={() => setExpanded(!expanded)}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
        {expanded && (
          <Box py={4} sx={{ display: "grid", gap: 6 }}>
            {courseInstructors.map((instructor) => (
              <Box
                key={instructor.id}
                display="flex"
                alignItems="center"
                gap={4}
              >
                <Avatar
                  src={instructor.image}
                  alt={instructor.name}
                  style={{ width: 65, height: 65 }}
                />
                <Box>
                  <Typography variant="h6">{instructor.name}</Typography>
                  <Typography variant="body2">
                    {instructor.designation}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default CourseInstructors;
